import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Organization from './Organization'

const OrganizationsWrapper = styled.div`
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
`

const Organizations = ({ organizations, dispatch, user }) => (
  <OrganizationsWrapper>
    {organizations.map(organization => (
      <Organization
        key={`user-org-${organization.id}`}
        dispatch={dispatch}
        organization={organization}
        user={user}
      />
    ))}
  </OrganizationsWrapper>
)

Organizations.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organizations: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired
}

export default Organizations



// WEBPACK FOOTER //
// ./src/components/mini/Organizations.js